import { ColumnDef } from '@tanstack/react-table'
import { AppButton, AppTable, AppTableProps, AppTypography, EmailText, PhoneText, TableActions } from 'components'
import { appRoutes } from 'globals/constants'
import { useStates } from 'hooks'
import { useNavigate } from 'react-router-dom'
import { CrmContactViewModel } from 'sdk'

interface Props extends AppTableProps<CrmContactViewModel> {
  onRemoveClick: (contactId: string) => void
}
export const CrmCompanyLinkedContactsTable = ({ onRemoveClick, ...props }: Props) => {
  const navigate = useNavigate()
  const { States } = useStates()
  const navigateToDetailRoute = (id: string) => {
    navigate(appRoutes.crmContactDetail.path.replace(':contactId', id))
  }

  const columns: ColumnDef<CrmContactViewModel>[] = [
    {
      id: 'popover',
      cell: ({ row }) => {
        return <TableActions row={row} actions={[{ text: 'Remove', onClick: () => onRemoveClick(row.original.Id!) }]} />
      },
    },
    {
      header: 'Name',
      cell: ({ row }) => {
        return (
          <>
            {!!row.original.ContactFirstName || !!row.original.ContactLastName ? (
              <AppTypography
                onClick={() => navigateToDetailRoute(row.original.Id!)}
                component={'a'}
                color={'primary.200'}
              >
                {(row.original.ContactFirstName ?? '') + ' ' + (row.original.ContactLastName ?? '')}
              </AppTypography>
            ) : (
              <AppButton onClick={() => navigateToDetailRoute(row.original.Id!)}></AppButton>
            )}
          </>
        )
      },
    },
    {
      header: 'Address',
      cell: ({ row }) => {
        return (
          <>
            {!!row.original.ContactAddress ||
            !!row.original.ContactAddress2 ||
            !!row.original.ContactCity ||
            !!row.original.ContactStateId ? (
              <AppTypography onClick={() => navigateToDetailRoute(row.original.Id!)} color={'primary.200'}>
                {row.original.ContactAddress ? row.original.ContactAddress + ', ' : ''}
                {row.original.ContactAddress2 ? row.original.ContactAddress2 + ', ' : ''}
                {row.original.ContactCity ? row.original.ContactCity + ', ' : ''}
                {row.original.ContactStateId
                  ? States.find((x) => x.Id === row.original.ContactStateId)?.Code + ' '
                  : ''}
                {row.original.ContactZip ?? ''}
              </AppTypography>
            ) : (
              <AppButton onClick={() => navigateToDetailRoute(row.original.Id!)}></AppButton>
            )}
          </>
        )
      },
    },
    {
      header: 'Email',
      accessorKey: 'Email',
      cell: ({ row }) => {
        return <EmailText email={row.original.ContactEmail ?? ''} />
      },
    },
    {
      header: 'Phone',
      accessorKey: 'Phone',
      cell: ({ row }) => {
        return <PhoneText phone={row.original.ContactPhone ?? ''} />
      },
    },
    {
      header: 'Alt Phone',
      accessorKey: 'AltPhone',
      cell: ({ row }) => {
        return <PhoneText phone={row.original.ContactAltPhone ?? ''} />
      },
    },
  ]
  return <AppTable columns={columns} {...props} />
}
